var React = require('react');

function ViewAsUser (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"currentColor","transform":"translate(-13 4)"},[React.createElement("circle",{"cx":"64","cy":"28","r":"18","key":0}),React.createElement("path",{"d":"\n      M34 88\n      A30 30 0 0 1 82 58\n      Q77 61 77 68\n      L77 88\n      Z\n    ","key":1}),React.createElement("path",{"d":"\n      M92 58\n      H116\n      C118 58 120 60 120 62\n      V106\n      C120 108 118 110 116 110\n      L104 100\n      L92 110\n      C90 110 88 108 88 106\n      V62\n      C88 60 90 58 92 58\n      Z\n    ","key":2})]));
}

ViewAsUser.defaultProps = {"viewBox":"0 0 128 128"};

module.exports = ViewAsUser;

ViewAsUser.default = ViewAsUser;
